import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getUSDTToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.USDT,
    symbol: 'USDT',
    addressL1: sdks.L1.getContractAddress('USDT'),
    addressL2: '',
    addressCronosEvm: '',
    decimals: 6,
    displayDecimals: 2,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/usdt.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="usdt"
        {...props}
      />
    ),
  };
};
